import { render, staticRenderFns } from "./RelatedFilesList.vue?vue&type=template&id=52b344b6&"
import script from "./RelatedFilesList.vue?vue&type=script&lang=js&"
export * from "./RelatedFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports